import React from 'react';  
import PropTypes from 'prop-types';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';
  
function DataTable({ data }) {  
    const getDisplayHeader = (header) => (
        typeof header === 'string' && header.toLowerCase().includes('unnamed') ? '-' : header
    );

    // Handle different data formats and ensure we have a flat array
    let flatData;
    
    // Handle null/undefined
    if (!data) {
        return <div>No data available.</div>;
    }
    
    // Handle array data
    if (Array.isArray(data)) {
        // eslint-disable-next-line react/prop-types
        if (data.length === 0) {
            return <div>No data available.</div>;
        }
        if (Array.isArray(data[0])) {
            flatData = data.flat();
        } else {
            flatData = data;
        }
    } 
    // Handle single object (convert to array)
    else if (typeof data === 'object') {
        flatData = [data];
    }
    // Handle other types
    else {
        return <div>Invalid data format.</div>;
    }
  
    if (!flatData || flatData.length === 0) {  
        return <div>No data available.</div>;  
    }  
  
    const columnHeaders = Object.keys(flatData[0]);  
    const validColumns = columnHeaders.filter((header) =>  
        flatData.some((row) => row[header] !== null && row[header] !== undefined)  
    );
    
    if (validColumns.length === 0) {
        return <div>No valid columns found.</div>;
    }
  
    return (  
        <TableContainer component={Paper}>  
            <Table style={{ borderCollapse: 'collapse', width: '100%' }}>  
                <TableHead>  
                    <TableRow>  
                        {validColumns.map((header) => (  
                            <TableCell style={{ border: '1px solid #e0e0e0', fontWeight: 'bold' }} sx={{ padding: '0px' }} key={header}>{getDisplayHeader(header)}</TableCell>  
                        ))}  
                    </TableRow>  
                </TableHead>  
                <TableBody>  
                    {flatData.map((row, rowIndex) => (  
                        <TableRow key={validColumns.map(col => row[col]).join('|')}>  
                            {validColumns.map((header, colIndex) => (  
                                <TableCell key={`${header}-${rowIndex}`} style={{ border: '1px solid #e0e0e0' }} sx={{ padding: '0px' }}>  
                                    {row[header] != null ? row[header].toString() : ''}  
                                </TableCell>  
                            ))}  
                        </TableRow>  
                    ))}  
                </TableBody>  
            </Table>  
        </TableContainer>  
    );  
}  
  
DataTable.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ])
};

export default DataTable;

